// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Head = require("next/head").default;

let make = Head;

exports.make = make;
/* make Not a pure module */
